import { throttle, memoize } from 'underscore';
// @ts-expect-error not migrated yet
import ModuleRender from 'ContentEditorUI/api/ModuleRender';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getRenderLanguage } from 'ContentEditorUI/redux/selectors/languageSelectors';
// @ts-expect-error not migrated yet
import createTicketer from 'EmailEditorUI/utils/createTicketer';
import { START_MODULE_RENDER, UPDATE_RENDERED_MODULE, UPDATE_RENDERED_CTA, UPDATE_RENDERED_IMAGE, UPDATE_RENDERED_RICH_TEXT } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
import { getBodyBorderWidth, getIsSingleColumnFullWidth
// @ts-expect-error not migrated yet
} from '../selectors/styleSettingsSelectors';
// @ts-expect-error not migrated yet
import { constrainImageDimensions } from 'EmailEditorUI/utils/moduleUtils';
// @ts-expect-error not migrated yet
import { getSections } from '../selectors/sectionSelectors';
import { getIsModuleUsingTokenValuesHelper, getElements } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import Raven from 'raven-js';
const renderModuleTickets = createTicketer();
const throttledRenderModuleFunctions = {};
const throttledRenderImageModuleFunctions = {};
function renderModuleFunc(moduleParam, callbackParam, contentId, contentPatch = null, useCachedContent = false, widgetColumnId, widgetSectionId) {
  const moduleData = moduleParam.toJS();
  const renderPromise = contentId && contentPatch ? ModuleRender.renderWithContext({
    data: {
      widgetParams: moduleData,
      contentId,
      contentPatch,
      useCachedContent,
      widgetColumnId,
      widgetSectionId
    },
    getParams: {
      contentId,
      inpageEditorUI: true,
      hsEditorApp: 'email'
    }
  }) : ModuleRender.render({
    data: moduleData,
    getParams: {
      contentId
    }
  });
  if (!contentId || !contentPatch) {
    Raven.capturePageEvent('callingWidgetAPIEvent', {
      extra: {
        moduleData,
        contentId,
        contentPatch,
        useCachedContent,
        widgetColumnId,
        widgetSectionId
      }
    });
  }
  return renderPromise.then(resp => callbackParam(resp), () => 'ERROR');
}
function renderModuleRequest(module, renderFunc = renderModuleFunc, callbackParam, contentId, contentPatch = null, useCachedContent = false, widgetColumnId, widgetSectionId) {
  if (!throttledRenderModuleFunctions[module.get('id')]) {
    throttledRenderModuleFunctions[module.get('id')] = throttle(renderFunc, 50);
  }
  throttledRenderModuleFunctions[module.get('id')](module, callbackParam, contentId, contentPatch, useCachedContent, widgetColumnId, widgetSectionId);
}
export function withLanguage(module, getState) {
  const language = getRenderLanguage(getState());
  return module.set('language', language);
}
function getColumnAndSectionIds(module, sections) {
  for (const section of sections) {
    const widgetColumn = section.get('columns').find(column => column.get('widgets').find(widget => widget.includes(module.get('id'))));
    if (widgetColumn) {
      return {
        widgetColumnId: widgetColumn.get('id'),
        widgetSectionId: section.get('id')
      };
    }
  }
  return {};
}
const getThrottledRenderModuleRequest = memoize(__cacheKey => throttle(renderModuleRequest, 300));
function renderModuleBase(module, dispatchMethod, clearRendered = false, contentId = null, contentPatch = null, useCachedContent = false, renderFunc = renderModuleFunc) {
  const moduleId = module.get('_isBuiltIn') ? module.get('type') : module.get('id');
  return (dispatch, getState) => {
    const ticket = renderModuleTickets.getTicket(moduleId);
    const throttledRenderModuleRequest = getThrottledRenderModuleRequest(moduleId);
    dispatch({
      type: START_MODULE_RENDER,
      id: moduleId,
      clearRendered
    });
    if (getIsModuleUsingTokenValuesHelper(module)) {
      contentPatch = contentPatch || {};
    }
    const {
      widgetColumnId,
      widgetSectionId
    } = getColumnAndSectionIds(module, getSections(getState()));
    throttledRenderModuleRequest(withLanguage(module, getState), renderFunc, resp => {
      if (renderModuleTickets.shouldHandleTicket(ticket)) {
        dispatch(dispatchMethod({
          id: moduleId,
          renderedModule: resp,
          hasError: resp === 'ERROR'
        }));
      }
    }, contentId || getContentModelId(getState()), contentPatch, useCachedContent, widgetColumnId, widgetSectionId);
  };
}
export function updateRenderedModule(data) {
  const {
    id,
    renderedModule,
    hasError
  } = data;
  return {
    type: UPDATE_RENDERED_MODULE,
    id,
    renderedModule,
    hasError
  };
}
export function updateRenderedCtaModule(data) {
  const {
    id,
    renderedModule
  } = data;
  return {
    type: UPDATE_RENDERED_CTA,
    id,
    renderedModule
  };
}
export function updateRenderedRichTextModule(data) {
  const {
    id,
    html
  } = data;
  return {
    type: UPDATE_RENDERED_RICH_TEXT,
    id,
    html
  };
}
export function renderModule(module, clearRendered, contentId, contentPatch, useCachedContent, renderFunc = renderModuleFunc) {
  return renderModuleBase(module, updateRenderedModule, clearRendered, contentId, contentPatch, useCachedContent, renderFunc);
}
export function renderCtaModule(module, renderFunc = renderModuleFunc) {
  return renderModuleBase(module, updateRenderedCtaModule, false, null, {}, false, renderFunc);
}
function renderImageModuleFunc(dispatch, getState, module) {
  const state = getState();
  const bodyBorderWidth = getBodyBorderWidth(state);
  dispatch({
    type: UPDATE_RENDERED_IMAGE,
    module: constrainImageDimensions(module, getSections(state), getIsSingleColumnFullWidth(state), bodyBorderWidth)
  });
}
export function renderImageModule(module) {
  return (dispatch, getState) => {
    const moduleId = module.get('id');
    if (!throttledRenderImageModuleFunctions[moduleId]) {
      throttledRenderImageModuleFunctions[moduleId] = throttle(renderImageModuleFunc, 50);
    }
    throttledRenderImageModuleFunctions[moduleId](dispatch, getState, module);
  };
}
export function rerenderModules({
  filter,
  contentId = null,
  contentPatch = {}
} = {}) {
  return (dispatch, getState) => {
    let modules = getElements(getState());
    if (typeof filter === 'function') {
      modules = modules.filter(filter);
    }
    modules.map(module => dispatch(renderModule(module, true, contentId, contentPatch, false)));
  };
}